import { useEffect } from "react";

export function useDocumentTitle(title: string, description?: string): void {
  useEffect(() => {
    document.title = title;

    if (!description) return;

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", description);
  }, [title, description]);
}
